const HOSPITAL_DEMO = -110;
const GOD_ROLE = "God";
const NO_GROUP = -1;
const REFRESH_SETTINGS = {
    checkWindow: 60000,
    refreshAt: 300000,
};

export { HOSPITAL_DEMO, GOD_ROLE, NO_GROUP, REFRESH_SETTINGS };
